import {Component} from '@angular/core';

import {ControlWidget} from '../../widget';

@Component({
  selector: 'sf-integer-widget',
  templateUrl: './sf-integer-widget.component.html'
})
export class IntegerWidgetComponent extends ControlWidget {
}



// WEBPACK FOOTER //
// ./src/app/schema-form/components/defaultwidgets/integer/sf-integer-widget.component.ts